import validate from "/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/nuxt@3.17.6_@parcel+watcher@2.5.1_@types+node@22.15.19_@vue+compiler-sfc@3.5.17_better-_9bb9d2c35690c1949ae2e443e68d6aec/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/nuxt@3.17.6_@parcel+watcher@2.5.1_@types+node@22.15.19_@vue+compiler-sfc@3.5.17_better-_9bb9d2c35690c1949ae2e443e68d6aec/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/runner/work/nuxt.com/nuxt.com/app/middleware/auth.ts"),
  guest: () => import("/home/runner/work/nuxt.com/nuxt.com/app/middleware/guest.ts")
}